
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useState } from "react";
import RegisterPopup from "@/modules/register/RegisterPopup";
export default function TestGoogle() {
    const [showPopup, setShowPopup] = useState(false);
    useEffect(() => {
        setShowPopup(true);
    }, []);
    return (<>
      <div>Empty page</div>
      {showPopup && (<RegisterPopup onClose={() => {
                setShowPopup(false);
            }}/>)}
    </>);
}

    async function __Next_Translate__getStaticProps__19ac762d779__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/test-google',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19ac762d779__ as getStaticProps }
  